var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('v-footer',{attrs:{"font-szie":"8px","app":"","fixed":""}},[_c('v-spacer'),_c('div',{staticClass:"mr-3"},[_vm._v(" © "),_c('a',{attrs:{"href":_vm.website}},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" "+_vm._s(_vm.copyYear)+". "+_vm._s(_vm.$t('footer.allrightreserved'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }